import React, { ReactElement } from 'react'
import { Container, ContainerStatus, Content, Header, Title, TitleValue } from './styled'

interface HiperModalProps {
    show: boolean
    title: string
    hideFooter?: boolean
    children?: ReactElement
    renderTitle?: (title:string) => ReactElement
    onHide: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void | undefined
    href?: string
}

const HiperModal: React.FC<HiperModalProps> = ({ show, title, onHide, children, href, renderTitle }) => {
    return (
        <Container show={show}>
            <Header>
                {renderTitle ? (
                    renderTitle(title)
                ) : (
                    <Title>
                        {title}
                    </Title>
                )}

                <ContainerStatus>
                    <a href={href}>
                        <i onClick={onHide} className="fas fa-times"></i>
                    </a>
                </ContainerStatus>
            </Header>
            <Content id="containerSuperModal">{children}</Content>
        </Container>
    )
}

export default HiperModal
